import qs from 'qs';
import useAPI from '../core/hooks/useApi';

export const useGetScenariosByOptInId = optInId =>
  useAPI(`/api/scenarios?${qs.stringify({ optInId })}`);
